var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChina(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07-SELECCI\\xD3N-ESTRATEGIA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-6",
    transform: "translate(-839.000000, -725.000000)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image-copy-4",
    x: 839,
    y: 725.992718,
    width: 18,
    height: 12.0145631,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAZCAIAAADWhhu8AAAABGdBTUEAALGOfPtRkwAAAmpJREFUSA3tVk2LE0EQraruSTarWdwPQdSbogiCJwUPIgviybN/w6M/wKsg+Ge8e/a0CnuQCMFLDoou+xFnpqvK18km2V1QnFndk5WhpzvdXa/qdb1OuMN0ZsYfb1EHaE7uh6AMQ9/d8xst+iIeMDJKp4lMzAgP3MzN3BXInEHwpTiJMJ0nj1h3Kh7EjSc+p01uOQgHBvrUsSvJRlh5thzvdAmBTEOYh9akI2Arr+f8yekkileLeLNndTCS6QTm6wQgjCOD3LyyjcXFJiTCIhq6Dz2sqr4HZ4FYEUEamb488GTFpW5YdR2WVraBm4Eh6rUQb8RAtHw/hX6oNsVSkQZuozGJRqWkLPd8ZTN+eaE+rhmH2dAWYKrUv+u9R1b0zETXnxd7b+POp5LAplBitO4ffH9sVIGDxkgIbAaG0/lmO6/Fl+jCY7iS/a3i66uDODaPZFkC5IGqYZk+C+mkVBumtQDDealwjB67tPuuQ6XLMhfRTQzE2kRrwAtXYrhM1ZZzKZQLtpkdZgZSgpJf5GoYd99UoeTeEwtrZHtgMRuKEBro3i6WHnA9SPQD2TVDyk62r9MSosxi41CIGnGtAilHqE2tQhjMhYT1qN8T95k2Ch9UVGkLfeOsZsZsFe6jrC4TcgVSBsLlwqvh3NNOcS3aiNJ2DQ20QALMrEDgNuc2r7Ej/cm9hYsmq58NFY9aaU5hTukojb8+hRAE1aLJa53x0Oa9yOx3u9Us1S3K74TPPwM7xvAJDw2GRwqkwa6WS/+DtSTu+DbJKsIzF9jx6b87ymeWf6XPxOJhZmcDNkWZXEn/ChB/DaeufwIEagrrEsfRoAAAAABJRU5ErkJggg=="
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.adb1cc1c7af26c75eccaae1845898e5c.svg";
export { ForwardRef as ReactComponent };